/**
 * Send Live-Streaming Gift UseCase
 *
 * Live-streaming-gift variant: media-less, chat-less transaction carrying a
 * `broadcastingInfo` sub-object, a null notification and a computed
 * `groupChatId`. The audience tips the broadcaster during a live session.
 * Structurally the twin of the video-call path (SendVideoCallGiftUseCase):
 * validates inputs, delegates to GiftService and refreshes the local wallet on
 * success (the send debited the caller's wallet server-side).
 *
 * Flutter source: live_streaming_screen.dart:1397-1430 + send_gift_bottom_sheet.dart:159-208
 */
import type { SendLiveStreamingGiftInput } from '@/domain/input/gift/sendLiveStreamingGiftInput';
import type { GiftService } from '@/domain/services/gift/giftService';
import { RefreshWalletUseCase } from '@/domain/usecases/wallet/refreshWalletUseCase';

export class SendLiveStreamingGiftUseCase {
  constructor(
    private readonly giftService: GiftService,
    private readonly refreshWalletUseCase: RefreshWalletUseCase = new RefreshWalletUseCase(),
  ) {}

  async execute(input: SendLiveStreamingGiftInput): Promise<boolean> {
    if (input.instances <= 0) return false;

    const success = await this.giftService.executeSendLiveStreamingGift(input);

    if (success) {
      this.refreshWalletUseCase.execute();
    }

    return success;
  }
}
